import React from 'react';

const MenuFood = React.lazy(() => import('pages/MenuFood/pages/MenuFoodPage'));
const MenuFoodAdd = React.lazy(() => import('pages/MenuFood/pages/MenuFoodAdd'));

const MenuFoodRoute = [
  {
    path: '/menu-food',
    exact: true,
    name: 'Danh sách menu',
    component: MenuFood,
    // function: 'CRM_STAFF',
  },
  {
    path: '/menu-food/add',
    exact: true,
    name: 'Thêm mới menu',
    component: MenuFoodAdd,
    // function: 'CRM_STAFF',
  },
  {
    path: '/menu-food/detail/:id',
    exact: true,
    name: 'Chi tiết menu',
    component: MenuFoodAdd,
    // function: 'CRM_STAFF',
  },
  {
    path: '/menu-food/edit/:id',
    exact: true,
    name: 'Chỉnh sửa menu',
    component: MenuFoodAdd,
    // function: 'CRM_STAFF',
  },
];

export default MenuFoodRoute;
